import { Box } from '@mantine/core';
import type { EmbeddedPromptOut, Message } from '@repo/api-codegen';
import { memo, useMemo } from 'react';
import { MessageContentV3 } from '../../../components/AIAssistant/Messages/MessageContentV3';
import { MessageAiError } from '../../AiChat/components/MessageAiError';

export const AgentMessage = memo(
	({ prompt }: { prompt: EmbeddedPromptOut }) => {
		const messageContent = prompt.response?.content ?? '';

		const messages = useMemo(
			() =>
				prompt.structured_response?.length
					? prompt.structured_response
					: [
							{
								content: messageContent,
								sender: 'assistant',
								use_tools: [],
								tool_response: null,
							} as Message,
						],
			[prompt.structured_response, messageContent]
		);

		const shouldDisplayFailure = prompt.status === 'failed';
		const limitExceeded = useMemo(() => {
			if (!shouldDisplayFailure) return false;
			const failReasonLower = prompt.benchmark_raw?.fail_reason?.toLowerCase();
			return (
				failReasonLower?.includes('too long') ||
				failReasonLower?.includes('token limit') ||
				false
			);
		}, [shouldDisplayFailure, prompt.benchmark_raw?.fail_reason]);

		return (
			<Box>
				{shouldDisplayFailure ? (
					<MessageAiError limitExceeded={limitExceeded} />
				) : (
					<Box>
						{['running', 'completed', 'stopped'].includes(
							prompt.status ?? ''
						) && (
							<MessageContentV3
								messages={messages}
								isRunning={prompt.status === 'running'}
							/>
						)}
					</Box>
				)}
			</Box>
		);
	}
);
